import { cx } from "cva";
import { Card, CardProps } from "~/ui-library";

export type ResponsiveArticleCardProps<T extends React.ElementType = "div"> =
  CardProps<T>;

export const ResponsiveArticleCard = <T extends React.ElementType = "div">({
  as,
  className,
  children,
  ...rest
}: ResponsiveArticleCardProps<T>): JSX.Element => (
  <Card
    as={as || "div"}
    className={cx("px-s py-s md:px-m", className)}
    {...rest}
  >
    {children}
  </Card>
);
